/* Muscle IQ theme — behaviour ported from the approved prototype (src/app.js),
   with the demo cart replaced by Shopify's AJAX Cart API.
   Section scripts re-initialise in the theme editor via shopify:section:load. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var M = window.MIQ || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  /* shop money formats can contain HTML or entities (e.g. "&pound;{{amount}}" or "<span class=money>…"): clean once */
  var FMT = (function () {
    var f = M.moneyFormat || '£{{amount}}';
    try { var t = document.createElement('textarea'); t.innerHTML = f.replace(/<[^>]*>/g, ''); f = t.value; } catch (_) {}
    return f;
  })();
  function money(cents) {
    var fmt = FMT;
    var n = (cents / 100);
    function d(v, sep, dec) { var p = v.toFixed(2).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep); return p.join(dec); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return d(n, ',', '.').split('.')[0];
      if (k === 'amount_with_comma_separator') return d(n, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return d(n, '.', ',').split(',')[0];
      return d(n, ',', '.');
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    $('span', t).textContent = msg; t.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var f = $('.panel [data-close], .panel button', d); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawers() {
    var had = false;
    $$('.drawer.open').forEach(function (d) { had = true; d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); });
    if (had) lockScroll(false);
    if (had && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  /* page behind an open drawer (basket, menu) doesn't scroll; the scrollbar's width is kept so nothing jumps sideways */
  function lockScroll(on) {
    var h = document.documentElement;
    if (on) { var sb = window.innerWidth - h.clientWidth; h.style.setProperty('--sb-w', (sb > 0 ? sb : 0) + 'px'); h.classList.add('drawer-on'); }
    else if (!document.querySelector('.drawer.open')) h.classList.remove('drawer-on');
  }
  /* iPhone: a swipe on the dark backdrop must not scroll the page underneath */
  document.addEventListener('touchmove', function (e) { if (e.target.closest && e.target.closest('.drawer.open .scrim')) e.preventDefault(); }, { passive: false });
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-close]');
    if (c && c.closest('.drawer')) { if (c.tagName !== 'A' || c.getAttribute('href').charAt(0) === '#') e.preventDefault(); closeDrawers(); }
    if (e.target.closest('#burger')) openDrawer('menuDrawer');
    var cb = e.target.closest('#cartBtn');
    if (cb) { e.preventDefault(); openDrawer('cartDrawer'); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- cart ---------- */
  function renderCart(cart) {
    var cc = $('#cartCount');
    if (cc) { cc.textContent = cart.item_count; cc.hidden = !cart.item_count; }
    var sum = $('#cartSum'); if (sum) sum.textContent = money(cart.total_price);
    var box = $('#cartItems'); if (!box) return;
    var s = M.strings || {};
    if (!cart.items.length) {
      box.innerHTML = '<div class="cart-empty"><p>' + esc(s.empty) + '</p><a class="btn btn-ink" href="' + esc(M.routes.emptyLink || M.routes.collection) + '" data-close>' + esc(s.emptyCta) + '</a></div>';
      return;
    }
    box.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=144&height=144&crop=center' : '';
      var variant = it.product_has_only_default_variant ? '' : '<small>' + esc(it.variant_title) + '</small>';
      var pr = it.properties || {}, tag = '';
      if (pr._bundlerole === 'attachment') tag = '<small class="ci-link">' + esc(s.rackOption) + '</small>';
      else if (pr._gb_bundle_id) tag = '<small class="ci-link">' + esc(s.buildItem) + '</small>';
      return '<div class="ci' + (pr._bundlerole === 'attachment' ? ' ci-sub' : '') + '"><img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy"><div>' + tag + '<b>' + esc(it.product_title) + '</b>' + variant +
        '<small>' + esc(s.qty) + ' ' + it.quantity + '</small><button class="rm" type="button" data-rm="' + esc(it.key) + '">' + esc(s.remove) + '</button></div>' +
        '<span class="p">' + money(it.final_line_price) + '</span></div>';
    }).join('');
  }
  function getCart() { return fetch(M.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function addItems(items) {
    return fetch(M.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || (M.strings || {}).error); return j; });
    }).then(getCart).then(function (cart) {
      return badLines(cart).then(function (bad) { return bad.keys.length ? dropKeys(bad.keys, bad.msg) : cart; });
    }).then(function (cart) {
      renderCart(cart);
      document.dispatchEvent(new CustomEvent('miq:cart', { detail: cart }));
      return cart;
    });
  }
  /* ---------- linked bundles (same rules as the old theme's cart.js) ----------
     Gym builder lines: _gb_bundle_id; removing rack / home-rack / rack-colour / rack-handle removes the whole build.
     Rack configurator lines: _mainidtimestamp; removing the rack or a required option removes the whole set.
     Afterwards any bundle left without its main item is cleaned up. */
  function bundleId(p) { p = p || {}; return String(p._gb_bundle_id || p._mainidtimestamp || ''); }
  /* A required part: gym builder lines marked _gb_required = Yes (builds added before v0.51 have no mark, so the
     old list is used: rack, home rack, rack colour, rack handle); rack configurator: the rack or a required option. */
  var GB_OLD_REQUIRED = ['rack', 'home-rack', 'rack-colour', 'rack-handle'];
  function removesWhole(p) {
    p = p || {};
    if (p._gb_bundle_id) return p._gb_required ? p._gb_required === 'Yes' : GB_OLD_REQUIRED.indexOf(p._gb_component) > -1;
    if (p._mainidtimestamp) return p._bundlerole === 'main' || !!p._mandatorykey;
    return false;
  }
  /* Builds missing a required part (removed outside the warning: another tab, the cart URL, an app).
     Gym builds list their required parts in _gb_needs; rack builds in _mandatoryrequired on the rack line. */
  function incompleteKeys(cart) {
    var b = {};
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {}, id = bundleId(p); if (!id) return;
      var g = b[id] = b[id] || { keys: [], needs: [], have: [] };
      g.keys.push(it.key);
      if (p._gb_bundle_id) {
        g.have.push(p._gb_component);
        String(p._gb_needs || '').split(',').forEach(function (n) { n = n.trim(); if (n && g.needs.indexOf(n) < 0) g.needs.push(n); });
      } else {
        if (p._mandatorykey) g.have.push(p._mandatorykey);
        if (p._bundlerole === 'main') String(p._mandatoryrequired || '').split(',').forEach(function (n) { n = n.trim(); if (n && g.needs.indexOf(n) < 0) g.needs.push(n); });
      }
    });
    var out = [];
    Object.keys(b).forEach(function (id) {
      var g = b[id], miss = g.needs.filter(function (n) { return g.have.indexOf(n) < 0; });
      if (miss.length) out = out.concat(g.keys);
    });
    return out;
  }
  function isMain(p) {
    p = p || {};
    if (p._gb_bundle_id) return p._gb_component === 'rack' || p._gb_component === 'home-rack';
    if (p._mainidtimestamp) return p._bundlerole === 'main';
    return false;
  }
  function updateLines(updates) {
    return fetch((M.routes.cartUpdate || '/cart/update') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }
  function cleanOrphans(cart) {
    var b = {};
    cart.items.forEach(function (it) {
      var id = bundleId(it.properties); if (!id) return;
      b[id] = b[id] || { main: false, keys: [] }; b[id].keys.push(it.key); if (isMain(it.properties)) b[id].main = true;
    });
    var up = {}, any = false;
    Object.keys(b).forEach(function (id) { if (!b[id].main) b[id].keys.forEach(function (k) { up[k] = 0; any = true; }); });
    return any ? updateLines(up) : Promise.resolve(cart);
  }
  /* ---------- option-only items (theme settings > Option-only products) ----------
     Products with the option-only tag (the Hidden Items collection: rack heights, depths, stacks, gym pod options…)
     may only be bought inside a rack build (_mainidtimestamp) or a gym build (_gb_bundle_id). The list of lines that
     break this rule is worked out by Liquid (snippets/cart-guard-keys): inline on page load, then through
     ?sections=miq-cart-guard after each add and just before checkout. Any such line is removed. */
  function guardKeys() {
    var root = (M.routes.root || '/').replace(/\/$/, '') + '/';
    return fetch(root + '?sections=miq-cart-guard', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (j) {
        var h = (j && j['miq-cart-guard']) || '', m = h.match(/<script[^>]*data-cart-guard[^>]*>([\s\S]*?)<\/script>/);
        try { return m ? JSON.parse(m[1]) : []; } catch (e) { return []; }
      }).catch(function () { return []; });
  }
  function dropKeys(keys, msg) {
    if (!keys || !keys.length) return Promise.resolve(null);
    var up = {}; keys.forEach(function (k) { up[k] = 0; });
    return updateLines(up).then(cleanOrphans).then(getCart).then(function (cart) {
      renderCart(cart);
      document.dispatchEvent(new CustomEvent('miq:cart-sync', { detail: cart }));
      msg = msg || (M.strings || {}).optionOnlyRemoved; if (msg) toast(msg);
      return cart;
    });
  }
  /* everything that must go: option-only lines bought on their own, then builds missing a required part */
  function badLines(cart) {
    return guardKeys().then(function (keys) {
      if (keys.length) return { keys: keys, msg: (M.strings || {}).optionOnlyRemoved };
      var inc = incompleteKeys(cart);
      return { keys: inc, msg: (M.strings || {}).buildRemoved || 'We removed a build from your basket because a required part was missing.' };
    });
  }
  function guard() { return getCart().then(badLines).then(function (bad) { return dropKeys(bad.keys, bad.msg); }); }
  /* page load: option-only lines found by Liquid for this page view, then any incomplete build */
  (function () {
    var el = document.getElementById('miq-cart-guard'), keys = [];
    try { keys = JSON.parse((el && el.textContent) || '[]'); } catch (e) {}
    var onCart = /^\/cart\/?$/.test(location.pathname);
    (keys.length ? dropKeys(keys) : Promise.resolve(null)).then(function (c1) {
      return getCart().then(function (cart) {
        var inc = incompleteKeys(cart);
        return inc.length ? dropKeys(inc, (M.strings || {}).buildRemoved) : c1;
      });
    }).then(function (c) { if (c && onCart) location.reload(); }).catch(function () {});
  })();
  /* checkout: check again first (a line could have been added outside the theme since the page loaded).
     Fails open: if the check errors or takes longer than CHECK_MS, the shopper goes to checkout anyway
     (the same check already ran on page load and after every add). The button says "Checking your basket…"
     while it waits, and repeat taps are ignored. */
  var guardPass = false, CHECK_MS = 2500;
  function checking(el, on) {
    if (!el || el.tagName === 'A' && !el.textContent.trim()) return;
    if (on) {
      if (el.hasAttribute('data-miq-checking')) return;
      el.setAttribute('data-miq-checking', ''); el.setAttribute('aria-busy', 'true');
      if (el.tagName === 'INPUT') { el._miqTxt = el.value; el.value = (M.strings || {}).checkingBasket || 'Checking your basket…'; }
      else { el._miqHtml = el.innerHTML; el.textContent = (M.strings || {}).checkingBasket || 'Checking your basket…'; }
    } else if (el.hasAttribute('data-miq-checking')) {
      el.removeAttribute('data-miq-checking'); el.removeAttribute('aria-busy');
      if (el.tagName === 'INPUT') el.value = el._miqTxt; else el.innerHTML = el._miqHtml;
    }
  }
  function onCheckout(e) {
    if (guardPass) return;
    var el = e.type === 'submit' ? e.submitter : (e.target.closest && e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]'));
    if (!el || (e.type === 'submit' && el.name !== 'checkout')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (el.hasAttribute('data-miq-checking')) return;
    var done = false, timer;
    function go(why) {
      if (done) return; done = true; clearTimeout(timer); checking(el, false);
      if (why) { try { console.warn('[MIQ] basket check ' + why + ', continuing to checkout'); } catch (x) {} document.dispatchEvent(new CustomEvent('miq:checkout-check', { detail: { result: why } })); }
      guardPass = true; el.click(); setTimeout(function () { guardPass = false; }, 4000);
    }
    checking(el, true);
    timer = setTimeout(function () { go('timeout'); }, CHECK_MS);
    guard().then(function (cart) {
      if (done) return;
      if (cart) { done = true; clearTimeout(timer); checking(el, false); if (/^\/cart\/?$/.test(location.pathname)) location.reload(); return; }
      go();
    }, function () { go('error'); });
  }
  document.addEventListener('click', onCheckout, true);
  document.addEventListener('submit', onCheckout, true);
  /* Warning before a required part of a build is removed. Resolves true (remove the whole build) or false (keep). */
  var bw = null;
  function buildWarn(item, others) {
    var S = M.strings || {};
    if (!bw) {
      bw = document.createElement('div');
      bw.className = 'bw'; bw.hidden = true;
      bw.innerHTML = '<div class="bw-bg" data-bw-keep></div><div class="bw-box" role="alertdialog" aria-modal="true" aria-labelledby="bw-t" aria-describedby="bw-d">' +
        '<h2 id="bw-t" class="bw-t"></h2><p id="bw-d" class="bw-d"></p><ul class="bw-l" role="list"></ul>' +
        '<div class="bw-a"><button type="button" class="btn btn-ink bw-keep" data-bw-keep></button><button type="button" class="btn btn-ghost bw-rm" data-bw-rm></button></div></div>';
      document.body.appendChild(bw);
    }
    var name = item.product_title + (item.variant_title && !/^default title$/i.test(item.variant_title) ? ' (' + item.variant_title + ')' : '');
    $('.bw-t', bw).textContent = S.buildWarnTitle || 'This item is part of your build';
    $('.bw-d', bw).textContent = (S.buildWarnBody || '[item] is a required part of your build. Removing it will also remove the rest of this build:')
      .replace('[item]', name).replace('[count]', others.length);
    $('.bw-l', bw).innerHTML = others.map(function (i) {
      return '<li>' + esc(i.product_title) + (i.variant_title && !/^default title$/i.test(i.variant_title) ? ' <small>' + esc(i.variant_title) + '</small>' : '') + (i.quantity > 1 ? ' <small>× ' + i.quantity + '</small>' : '') + '</li>';
    }).join('');
    $('.bw-l', bw).hidden = !others.length;
    $('.bw-keep', bw).textContent = S.buildKeep || 'Keep my build';
    $('.bw-rm', bw).textContent = S.buildRemove || 'Remove whole build';
    var back = document.activeElement;
    bw.hidden = false; document.documentElement.classList.add('bw-open');
    setTimeout(function () { $('.bw-keep', bw).focus(); }, 30);
    return new Promise(function (done) {
      function close(ok) {
        bw.hidden = true; document.documentElement.classList.remove('bw-open');
        bw.removeEventListener('click', onClick); document.removeEventListener('keydown', onKey, true);
        if (back && back.focus && document.contains(back)) back.focus();
        done(ok);
      }
      function onClick(e) { if (e.target.closest('[data-bw-rm]')) close(true); else if (e.target.closest('[data-bw-keep]')) close(false); }
      function onKey(e) {
        if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(false); return; }
        if (e.key === 'Tab') {
          e.stopPropagation();
          var f = $$('button', bw), first = f[0], last = f[f.length - 1];
          if (!bw.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
      function onFocus(e) { if (!bw.hidden && !bw.contains(e.target)) { e.stopPropagation(); $('.bw-keep', bw).focus(); } }
      bw.addEventListener('click', onClick); document.addEventListener('keydown', onKey, true); document.addEventListener('focusin', onFocus, true);
      var _close = close; close = function (ok) { document.removeEventListener('focusin', onFocus, true); _close(ok); };
    });
  }
  /* Resolves with the cart, or with { cancelled: true } when the customer keeps the build. */
  function removeLine(key) {
    return getCart().then(function (cart) {
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      var id = item && bundleId(item.properties);
      var p = (item && item.properties) || {};
      /* a gym build can hold several lines of one required part (e.g. two sets of plates): removing one of them is fine */
      var sameKind = p._gb_bundle_id && cart.items.some(function (i) { return i.key !== key && bundleId(i.properties) === id && (i.properties || {})._gb_component === p._gb_component; });
      if (id && removesWhole(p) && !sameKind) {
        var others = cart.items.filter(function (i) { return i.key !== key && bundleId(i.properties) === id; });
        var ask = others.length ? buildWarn(item, others) : Promise.resolve(true);
        return ask.then(function (ok) {
          if (!ok) return { cancelled: true };
          var up = {}; cart.items.forEach(function (i) { if (bundleId(i.properties) === id) up[i.key] = 0; });
          return updateLines(up).then(cleanOrphans).then(function (c) { renderCart(c); return c; });
        });
      }
      return changeLine(key, 0, true).then(cleanOrphans).then(function (c) { renderCart(c); return c; });
    });
  }
  function changeLine(key, qty, raw) {
    return fetch(M.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { if (!raw) renderCart(cart); return cart; });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-add]');
    if (a) {
      e.preventDefault(); a.disabled = true;
      addItems([{ id: +a.dataset.add, quantity: 1 }]).then(function () {
        toast((M.strings.added || 'Added to cart') + ': ' + (a.dataset.title || ''));
      }).catch(function (err) { toast(err.message); }).then(function () { a.disabled = false; });
      return;
    }
    var rm = e.target.closest('[data-rm]');
    if (rm && rm.closest('#cartItems')) { e.preventDefault(); rm.disabled = true; removeLine(rm.dataset.rm).then(function (r) { if (r && r.cancelled) rm.disabled = false; }).catch(function () { rm.disabled = false; toast((M.strings || {}).error); getCart().then(renderCart); }); }
  });
  /* keep the cart fresh when returning via the back button */
  window.addEventListener('pageshow', function (e) { if (e.persisted) getCart().then(renderCart); });

  window.MIQ = M;
  /* Shopify Inbox chat button: sits just above any bar fixed to the bottom of the screen on phones
     (product page add-to-cart bar, gym builder total bar). See html.satc-on in miq-base.css. */
  var liftT = 0;
  function liftChat() {
    var h = 0, H = window.innerHeight;
    $$('.satc.show, .gb-bar').forEach(function (b) {
      var cs = getComputedStyle(b); if (cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = b.getBoundingClientRect(); if (r.height && r.top < H - 2) h = Math.max(h, Math.round(H - r.top));
    });
    var root = document.documentElement; root.classList.toggle('satc-on', h > 0);
    if (h > 0) root.style.setProperty('--miq-satc-h', h + 'px');
  }
  function liftSoon() { if (liftT) return; liftT = requestAnimationFrame(function () { liftT = 0; liftChat(); }); }
  window.addEventListener('scroll', liftSoon, { passive: true }); window.addEventListener('resize', liftSoon);
  window.addEventListener('load', liftChat); document.addEventListener('DOMContentLoaded', liftChat);
  M.liftChat = liftChat;
  M.toast = toast; M.openDrawer = openDrawer; M.closeDrawers = closeDrawers; M.money = money;
  M.cart = { add: addItems, change: changeLine, remove: removeLine, get: getCart, render: renderCart };

  /* ---------- sign-up pop-up guard (Klaviyo) ----------
     Klaviyo's pop-up opens on a timer. If it lands while the basket or menu drawer is open, or while the visitor is
     heading to checkout, it is held out of sight (and out of the tab order) and shown again once the drawer closes.
     Nothing is held on the checkout itself (Shopify's checkout doesn't run theme code). */
  (function () {
    var html = document.documentElement, held = [];
    function busy() { return html.classList.contains('drawer-on') || html.classList.contains('miq-leaving'); }
    function popups() {
      var out = [];
      $$('body > *').forEach(function (n) {
        if (n.hasAttribute('data-miq-held')) return;
        if (n.matches && (n.matches('[class*="kl-private-reset-css"]') || n.querySelector('[class*="kl-private-reset-css"][role="dialog"], [aria-label="POPUP Form"]'))) {
          if (n.querySelector('[role="dialog"]') || (n.getAttribute && n.getAttribute('role') === 'dialog')) out.push(n);
        }
      });
      return out;
    }
    function hold() {
      if (!busy()) return;
      popups().forEach(function (n) {
        n.setAttribute('data-miq-held', ''); n.setAttribute('inert', ''); n.setAttribute('aria-hidden', 'true');
        n.style.setProperty('visibility', 'hidden', 'important'); held.push(n);
      });
      /* keep keyboard focus in the open drawer if the pop-up grabbed it */
      var d = $('.drawer.open');
      if (d && !d.contains(document.activeElement)) { var f = $('.panel [data-close], .panel button', d); if (f) f.focus(); }
    }
    function release() {
      if (busy() || !held.length) return;
      var back = null;
      held.forEach(function (n) { n.removeAttribute('data-miq-held'); n.removeAttribute('inert'); n.removeAttribute('aria-hidden'); n.style.removeProperty('visibility'); if (!back) back = n.querySelector('[role="dialog"] button, [role="dialog"] a, [role="dialog"] input'); });
      held = [];
      /* the pop-up is a modal dialog: once it is shown, keyboard focus goes into it */
      if (back) setTimeout(function () { try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); } }, 60);
    }
    window.addEventListener('klaviyoForms', function (e) { if (e.detail && e.detail.type === 'open') setTimeout(hold, 0); });
    new MutationObserver(function () { if (busy()) hold(); }).observe(document.body, { childList: true });
    new MutationObserver(function () { if (busy()) hold(); else release(); }).observe(html, { attributes: true, attributeFilter: ['class'] });
    /* checkout: the basket form's checkout button, the cart page and any checkout link */
    document.addEventListener('submit', function (e) { var f = e.target; if (f && (f.action || '').indexOf('/cart') > -1 && e.submitter && e.submitter.name === 'checkout') { html.classList.add('miq-leaving'); hold(); } }, true);
    document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href*="/checkout"], button[name="checkout"]'); if (a) { html.classList.add('miq-leaving'); hold(); } }, true);
    /* back/forward cache: a visitor who comes back from checkout gets normal behaviour */
    window.addEventListener('pageshow', function (e) { if (e.persisted) { html.classList.remove('miq-leaving'); release(); } });
  })();

  /* ---------- cookie settings link ----------
     Re-opens Shopify's cookie banner (Settings > Customer privacy). Works for links marked data-cookie-settings
     (footer links named "Cookies settings") and for any link ending in #shopifyReshowConsentBanner or #cookie-settings. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-cookie-settings], a[href$="#shopifyReshowConsentBanner"], a[href$="#cookie-settings"]');
    if (!a) return;
    var pb = window.privacyBanner;
    if (pb && typeof pb.showPreferences === 'function') { e.preventDefault(); pb.showPreferences(); return; }
    if (a.hasAttribute('data-cookie-settings') && !/#shopifyReshowConsentBanner$/.test(a.getAttribute('href') || '')) {
      /* hand over to Shopify's own handler for this hash rather than following a wrong link */
      e.preventDefault(); location.hash = 'shopifyReshowConsentBanner';
    }
  });

  /* ---------- header ---------- */
  var hdr = $('[data-header]');
  if (hdr) window.addEventListener('scroll', function () { hdr.classList.toggle('scrolled', window.scrollY > 40); }, { passive: true });
  document.addEventListener('click', function (e) { var f = e.target.closest('#hsearch'); if (f && !e.target.closest('#hsearchRes')) { var q = $('#q'); if (q && document.activeElement !== q) { try { q.focus({ preventScroll: true }); } catch (err) { q.focus(); } } } });

  /* ---------- search suggestions (Shopify predictive search) ----------
     Used by the desktop header search (dropdown) and the mobile overlay.
     Empty box: popular searches + a few products (template#srchEmpty). Typing: live results. */
  function searchBox(input, res, onShow) {
    var L = (document.getElementById('srchLabels') || {}).dataset || {}, tpl = document.getElementById('srchEmpty');
    var timer, ctl, lastQ = null;
    function img(u) { if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120'; }
    function put(h) { res.innerHTML = h; if (onShow) onShow(!!h); }
    function empty() { lastQ = ''; put(tpl ? tpl.innerHTML.trim() : ''); }
    function render(q, j) {
      var r = (j && j.resources && j.resources.results) || {}, prods = r.products || [], cols = r.collections || [], h = '';
      if (cols.length) h += '<p class="msearch-h">' + esc(L.lCollections) + '</p><ul class="msearch-cols">' + cols.map(function (c) { return '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; }).join('') + '</ul>';
      if (prods.length) h += '<p class="msearch-h">' + esc(L.lProducts) + '</p><ul class="msearch-prods">' + prods.map(function (p) {
        var price = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
        return '<li><a href="' + esc(p.url) + '"><span class="msearch-img">' + (p.image ? '<img src="' + esc(img(p.image)) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span><span class="msearch-t">' + esc(p.title) + '</span><span class="msearch-p mono">' + price + '</span></a></li>';
      }).join('') + '</ul>';
      if (!prods.length && !cols.length) h = '<p class="msearch-none">' + esc(L.lNone) + ' “' + esc(q) + '”</p>';
      h += '<a class="msearch-all" href="' + esc((M.routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last') + '">' + esc(L.lAll) + ' “' + esc(q) + '” <svg aria-hidden="true"><use href="#i-arrow"/></svg></a>';
      put(h);
    }
    function update() {
      var q = input.value.trim(); clearTimeout(timer);
      if (q.length < 2) { if (lastQ !== '') empty(); return; }
      timer = setTimeout(function () {
        if (q === lastQ) return; lastQ = q;
        if (ctl) ctl.abort(); ctl = window.AbortController ? new AbortController() : null;
        fetch((M.routes.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag', ctl ? { signal: ctl.signal } : {})
          .then(function (r) { return r.json(); }).then(function (j) { if (input.value.trim() === q) render(q, j); }).catch(function () {});
      }, 180);
    }
    input.addEventListener('input', update);
    return { refresh: function () { lastQ = null; update(); } };
  }

  /* mobile/tablet: full-screen overlay */
  (function () {
    var ov = document.getElementById('mSearch'); if (!ov) return;
    var input = $('#mq', ov), res = $('[data-msearch-res]', ov), opener = null;
    var box = searchBox(input, res);
    function open(e) { if (e) e.preventDefault(); opener = document.activeElement; ov.hidden = false; box.refresh(); document.documentElement.classList.add('msearch-on'); requestAnimationFrame(function () { ov.classList.add('on'); input.focus(); if (input.value) input.select(); }); }
    function close() { ov.classList.remove('on'); document.documentElement.classList.remove('msearch-on'); setTimeout(function () { ov.hidden = true; }, 200); if (opener && opener.focus) opener.focus(); }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-msearch-open]')) open(e);
      else if (e.target.closest('[data-msearch-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) close(); });
  })();

  /* desktop: dropdown under the header search */
  (function () {
    var form = document.getElementById('hsearch'), input = $('#q'), res = document.getElementById('hsearchRes');
    if (!form || !input || !res) return;
    var box = searchBox(input, res, function (has) { res.hidden = !has || document.activeElement !== input && !res.contains(document.activeElement); });
    /* keep focus in the box while clicking a suggestion, so the dropdown doesn't close under the pointer */
    res.addEventListener('mousedown', function (e) { if (e.target.closest('a')) e.preventDefault(); });
    var quiet = false;
    input.addEventListener('focus', function () { if (quiet) { quiet = false; return; } box.refresh(); res.hidden = !res.innerHTML; });
    input.addEventListener('click', function () { if (res.hidden && res.innerHTML) res.hidden = false; });
    form.addEventListener('focusout', function () { setTimeout(function () { if (!form.contains(document.activeElement)) res.hidden = true; }, 120); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { res.hidden = true; input.blur(); }
      else if (e.key === 'ArrowDown') { var f = res.querySelector('a'); if (f) { e.preventDefault(); f.focus(); } }
    });
    res.addEventListener('keydown', function (e) {
      var links = [].slice.call(res.querySelectorAll('a')), i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i > -1) { e.preventDefault(); (links[i + 1] || links[i]).focus(); }
      else if (e.key === 'ArrowUp' && i > -1) { e.preventDefault(); (i ? links[i - 1] : input).focus(); }
      else if (e.key === 'Escape') { quiet = true; input.focus(); res.hidden = true; }
    });
  })();

  /* ============ section initialisers ============ */
  var INIT = {};

  /* hero slider (prototype: "Homepage v2: cinematic") */
  INIT.hero = function (root) {
    var sl = $$('.cs', root), dots = $$('.dots [data-go]', root), i = 0;
    if (!sl.length) return;
    var T = (+root.dataset.speed || 7) * 1000, t0 = performance.now(), paused = false, alive = true;
    function go(n) {
      i = (n + sl.length) % sl.length;
      sl.forEach(function (s, k) {
        var on = k === i; s.classList.toggle('on', on); s.setAttribute('aria-hidden', !on);
        $$('a,button', s).forEach(function (x) { x.tabIndex = on ? 0 : -1; });
        if (on) $$('img[loading="lazy"]', s).forEach(function (im) { im.loading = 'eager'; });
      });
      dots.forEach(function (d, k) { d.setAttribute('aria-selected', k === i); var em = $('em', d); if (em) em.style.width = k < i ? '100%' : '0%'; });
      t0 = performance.now();
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.go); }); });
    $$('.cs-ctrl [data-step]', root).forEach(function (b) { b.addEventListener('click', function () { go(i + (+b.dataset.step)); }); });
    /* no pause on hover or tap; only keyboard users tabbing into a slide pause it, so it can't move away mid-read */
    root.addEventListener('focusin', function (e) { var t = e.target; try { if (t.matches(':focus-visible')) paused = true; } catch (err) {} });
    root.addEventListener('focusout', function () { paused = false; });
    var wrap = $('.cs-wrap', root), x0 = null;
    wrap.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    wrap.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
    function tick(now) {
      if (!alive || !document.body.contains(root)) return;
      requestAnimationFrame(tick);
      if (reduce || sl.length < 2 || root.dataset.autoplay === 'false') return;
      var em = $('em', dots[i]); if (!em) return;
      if (paused) { t0 = now - (parseFloat(em.style.width) || 0) / 100 * T; return; }
      var p = Math.min(1, (now - t0) / T); em.style.width = (p * 100) + '%';
      if (p >= 1) go(i + 1);
    }
    go(0); requestAnimationFrame(tick);
    root._miqStop = function () { alive = false; };
    root._miqGo = go;
  };

  /* "Hot right now" tabs: each tab has its own server-rendered grid */
  INIT.tabs = function (root) {
    var tabs = $$('[role="tab"]', root);
    function show(k) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.tab === k); t.tabIndex = t.dataset.tab === k ? 0 : -1; });
      $$('[data-panel]', root).forEach(function (p) { p.hidden = p.dataset.panel !== k; });
    }
    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () { show(t.dataset.tab); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return;
        var nx = tabs[(n + d + tabs.length) % tabs.length]; nx.focus(); show(nx.dataset.tab);
      });
    });
  };

  /* planning tools */
  INIT.tools = function (root) {
    $$('[data-tool="level"]', root).forEach(function (seg) {
      var tool = seg.closest('.tool');
      $$('button', seg).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('button', seg).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
          $$('[data-level]', tool).forEach(function (o) { o.hidden = o.dataset.level !== b.dataset.v; });
        });
      });
    });
    $$('[data-rack-tool]', root).forEach(function (tool) {
      var ceil = $('[data-ceil]', tool), rack = $('[data-rack]', tool), o = $('[data-out]', tool);
      function run() {
        var c = +ceil.value, r = +rack.value;
        if (!c || !r) { o.innerHTML = '<p>Enter both heights in cm.</p>'; return; }
        var cl = c - r, st, msg;
        if (cl >= 30) { st = 'ok'; msg = 'Room for regular pull-ups'; }
        else if (cl >= 20) { st = 'ok'; msg = 'Fits, with room for occasional pull-ups'; }
        else if (cl >= 10) { st = 'warn'; msg = 'Fits for rack use. Tight for pull-ups'; }
        else if (cl >= 0) { st = 'bad'; msg = 'Too tight. Aim for at least 10cm clearance'; }
        else { st = 'bad'; msg = 'Will not fit. The rack is ' + Math.abs(cl) + 'cm taller than your ceiling'; }
        o.innerHTML = '<div class="gauge"><b class="mono">' + cl + 'cm</b><span>clearance</span></div><p class="st ' + st + '">' + msg + '</p><small>Rule of thumb: leave 10cm for rack-only use, 20cm+ for occasional pull-ups and 30cm+ for regular pull-ups. Allow for your flooring too.</small>';
      }
      var more = $('.tool-ft a', tool), base = more && more.getAttribute('href');
      function carry() { if (more && base && base.charAt(0) !== '#' && +ceil.value && +rack.value) more.href = base.split('?')[0] + '?ceiling=' + encodeURIComponent(+ceil.value) + '&rack=' + encodeURIComponent(+rack.value); }
      ceil.addEventListener('input', function () { run(); carry(); }); rack.addEventListener('input', function () { run(); carry(); }); run(); carry();
    });
    $$('[data-floor-tool]', root).forEach(function (tool) {
      var L = $('[data-len]', tool), W = $('[data-wid]', tool), o = $('[data-out]', tool);
      function run() {
        var l = +L.value, w = +W.value;
        if (!l || !w) { o.innerHTML = '<p>Enter your room size in metres.</p>'; return; }
        var area = l * w, need = area * 1.1, tiles = Math.ceil(need);
        o.innerHTML = '<div class="gauge"><b class="mono">' + tiles + '</b><span>1m × 1m tiles</span></div><p class="st ok">' + area.toFixed(1) + 'm² room · ' + need.toFixed(1) + 'm² with 10% extra for cuts</p><small>Thickness guide: 10mm cardio, 15mm home strength, 20mm+ heavy lifting, 30mm+ high-impact areas.</small>';
      }
      var more = $('.tool-ft a', tool), base = more && more.getAttribute('href');
      function carry() { if (more && base && base.charAt(0) !== '#' && +L.value && +W.value) more.href = base.split('?')[0] + '?length=' + encodeURIComponent(+L.value) + '&width=' + encodeURIComponent(+W.value); }
      L.addEventListener('input', function () { run(); carry(); }); W.addEventListener('input', function () { run(); carry(); }); run(); carry();
    });
  };

  function initAll(scope) {
    $$('[data-miq]', scope || document).forEach(function (el) {
      if (el._miqInit) return; var fn = INIT[el.dataset.miq];
      if (fn) { el._miqInit = true; fn(el); }
    });
  }
  M.init = initAll; M.INIT = INIT;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { $$('[data-miq]', e.target).forEach(function (el) { if (el._miqStop) el._miqStop(); }); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.cs'); if (!slide) return;
    var root = slide.closest('[data-miq="hero"]'); if (root && root._miqGo) root._miqGo(+slide.dataset.i);
  });
})();


/* desktop menu pill.
   Scrolling: when the menu is too long it scrolls sideways. Mouse users get arrow buttons, the wheel and drag;
   the edge that has more links fades. The current page's link is brought into view.
   Mega menu: links with data-mm open their panel on hover, focus or tap; Escape or leaving the header closes it. */
(function () {
  function initPill() {
    var pill = document.querySelector('.hdr [data-nav-pill]'); if (!pill || pill._init) return; pill._init = true;
    var wrap = pill.closest('[data-nav-wrap]'), arrows = wrap ? [].slice.call(wrap.querySelectorAll('[data-np-arr]')) : [];
    function upd() {
      var more = pill.scrollWidth - pill.clientWidth > 2;
      var r = more && pill.scrollLeft + pill.clientWidth < pill.scrollWidth - 2, l = more && pill.scrollLeft > 2;
      pill.classList.toggle('more-r', r); pill.classList.toggle('more-l', l);
      arrows.forEach(function (a) { a.hidden = +a.dataset.npArr > 0 ? !r : !l; });
    }
    var cur = pill.querySelector('[aria-current]');
    if (cur && pill.scrollWidth > pill.clientWidth) pill.scrollLeft = Math.max(0, cur.offsetLeft - (pill.clientWidth - cur.offsetWidth) / 2);
    arrows.forEach(function (a) { a.addEventListener('click', function () { pill.scrollBy({ left: (+a.dataset.npArr) * Math.max(160, pill.clientWidth * 0.6), behavior: 'smooth' }); }); });
    /* a vertical mouse wheel over the menu scrolls it sideways (only while it can still scroll that way) */
    pill.addEventListener('wheel', function (e) {
      if (pill.scrollWidth <= pill.clientWidth || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      var max = pill.scrollWidth - pill.clientWidth, next = Math.max(0, Math.min(max, pill.scrollLeft + e.deltaY));
      if (next === pill.scrollLeft) return; e.preventDefault(); pill.scrollLeft = next;
    }, { passive: false });
    /* drag with the mouse */
    var down = false, x0 = 0, s0 = 0, moved = 0;
    pill.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0 || pill.scrollWidth <= pill.clientWidth) return; down = true; moved = 0; x0 = e.clientX; s0 = pill.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (!down) return; moved = Math.abs(e.clientX - x0); if (moved > 6) { pill.classList.add('dragging'); pill.scrollLeft = s0 - (e.clientX - x0); } });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { pill.classList.remove('dragging'); }, 0); });
    pill.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    pill.addEventListener('dragstart', function (e) { e.preventDefault(); });
    pill.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(upd);
    upd();
  }

  function initMega() {
    var hdr = document.querySelector('.hdr'); if (!hdr || hdr._mm) return;
    var links = [].slice.call(hdr.querySelectorAll('[data-mm]')); if (!links.length) return; hdr._mm = true;
    var openId = null, tOpen = null, tClose = null, quiet = false;
    var desktop = function () { return window.innerWidth > 1080; };
    var hoverable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function panel(id) { return document.getElementById(id); }
    function show(id) {
      clearTimeout(tClose); if (openId === id) return;
      /* tell the card how much window height is left under the header */
      hdr.style.setProperty('--mm-top', Math.round(hdr.getBoundingClientRect().bottom + 8) + 'px');
      links.forEach(function (a) { var on = a.dataset.mm === id; a.setAttribute('aria-expanded', on ? 'true' : 'false'); var p = panel(a.dataset.mm); if (p) p.hidden = !on; });
      openId = id;
    }
    function close() { clearTimeout(tOpen); if (!openId) return; links.forEach(function (a) { a.setAttribute('aria-expanded', 'false'); var p = panel(a.dataset.mm); if (p) p.hidden = true; }); openId = null; }
    function later() { clearTimeout(tOpen); clearTimeout(tClose); tClose = setTimeout(close, 220); }
    links.forEach(function (a) {
      a.addEventListener('mouseenter', function () { if (!desktop() || !hoverable) return; clearTimeout(tClose); clearTimeout(tOpen); tOpen = setTimeout(function () { show(a.dataset.mm); }, openId ? 0 : 110); });
      a.addEventListener('focus', function () { if (quiet) { quiet = false; return; } if (desktop()) show(a.dataset.mm); });
      /* with a mouse a click always follows the link (hover has opened the panel); on touch the first tap opens the panel, the second follows the link */
      a.addEventListener('click', function (e) { if (!desktop() || hoverable) return; if (openId !== a.dataset.mm) { e.preventDefault(); show(a.dataset.mm); } });
      a.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); show(a.dataset.mm); var f = panel(a.dataset.mm).querySelector('a'); if (f) f.focus(); }
      });
    });
    /* inside a panel: hovering or focusing a category in the left list shows its pane; Right arrow steps into the pane */
    [].slice.call(hdr.querySelectorAll('[data-mm-tab]')).forEach(function (t) {
      var card = t.closest('.mm-card');
      function pick() {
        [].slice.call(card.querySelectorAll('[data-mm-tab]')).forEach(function (x) { if (x === t) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); });
        [].slice.call(card.querySelectorAll('.mm-pane')).forEach(function (pn) { pn.hidden = pn.id !== t.dataset.mmTab; });
      }
      var th = null;
      /* moving the mouse sideways towards the pane often crosses another category: wait longer in that case so the pane does not flip */
      t.addEventListener('mouseenter', function () { clearTimeout(th); th = setTimeout(pick, (card._vx > 2 && card._vx > Math.abs(card._vy) * 1.2) ? 320 : 70); });
      t.addEventListener('mouseleave', function () { clearTimeout(th); });
      t.addEventListener('focus', pick);
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { pick(); var f = document.getElementById(t.dataset.mmTab).querySelector('a'); if (f) { e.preventDefault(); f.focus(); } }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { var all = [].slice.call(card.querySelectorAll('[data-mm-tab]')), k = all.indexOf(t) + (e.key === 'ArrowDown' ? 1 : -1); if (all[k]) { e.preventDefault(); all[k].focus(); } }
      });
      /* touch: the first tap on a category shows its pane, the second follows the link */
      t.addEventListener('click', function (e) { if (hoverable) return; if (t.getAttribute('aria-current') !== 'true') { e.preventDefault(); pick(); } });
    });
    [].slice.call(hdr.querySelectorAll('.mm-rail')).forEach(function (rail) {
      var card = rail.closest('.mm-card'), px = null, py = null;
      rail.addEventListener('mousemove', function (e) { if (px !== null) { card._vx = e.clientX - px; card._vy = e.clientY - py; } px = e.clientX; py = e.clientY; });
      rail.addEventListener('mouseleave', function () { px = null; card._vx = 0; card._vy = 0; });
    });
    /* plain links in the menu close whatever is open */
    [].slice.call(hdr.querySelectorAll('.np:not([data-mm])')).forEach(function (a) { a.addEventListener('mouseenter', later); a.addEventListener('focus', close); });
    hdr.addEventListener('mouseleave', later);
    hdr.addEventListener('mouseenter', function () { clearTimeout(tClose); });
    [].slice.call(hdr.querySelectorAll('[data-mm-panel]')).forEach(function (p) { p.addEventListener('mouseenter', function () { clearTimeout(tClose); }); });
    var pillEl = hdr.querySelector('[data-nav-pill]'); if (pillEl) pillEl.addEventListener('mouseenter', function () { clearTimeout(tClose); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !openId) return;
      var a = links.filter(function (l) { return l.dataset.mm === openId; })[0], inside = panel(openId).contains(document.activeElement);
      close(); if (inside && a) { quiet = true; a.focus(); }
    });
    document.addEventListener('click', function (e) { if (openId && !e.target.closest('.hdr')) close(); });
    document.addEventListener('focusin', function (e) { if (openId && !e.target.closest('.hdr')) close(); });
    window.addEventListener('resize', function () { if (!desktop()) close(); });
  }

  function init() { initPill(); initMega(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { var h = document.querySelector('.hdr'); if (h) h._mm = false; init(); });
})();

/* mobile menu: one screen at a time; a row with sub-links opens its screen, the back button returns */
(function () {
  function view(md, id, back) {
    var views = [].slice.call(md.querySelectorAll('[data-md-view]')), target = views.filter(function (v) { return v.getAttribute('data-md-view') === id; })[0]; if (!target) return;
    md.classList.toggle('back', !!back);
    views.forEach(function (v) { v.hidden = v !== target; });
    md.scrollTop = 0;
    var f = target.querySelector('.md-back') || target.querySelector('.md-row'); if (f && id !== 'root') { try { f.focus({ preventScroll: true }); } catch (e) {} }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-md-open]'); if (!b) return; var md = b.closest('[data-md]'); if (!md) return;
    e.preventDefault(); view(md, b.getAttribute('data-md-open'), b.classList.contains('md-back'));
  });
  /* opening the menu always starts on its first screen */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('#burger')) return; var md = document.querySelector('#menuDrawer [data-md]'); if (md) { md.classList.remove('back'); view(md, 'root'); }
  }, true);
})();

/* header search: opening or leaving the box must not move the page. If the browser shifts the scroll position by itself
   at that moment (and the visitor is not scrolling), put it back. */
(function () {
  var q = document.getElementById('q'); if (!q) return;
  var userScroll = 0;
  ['wheel', 'touchmove', 'keydown'].forEach(function (ev) { window.addEventListener(ev, function (e) { if (ev !== 'keydown' || /^(Arrow|Page|Home|End| )/.test(e.key)) userScroll = Date.now(); }, { passive: true }); });
  function guard(e) {
    var y0 = window.scrollY, t0 = Date.now(), left = 8;
    /* a click on a link or button is allowed to move the page */
    var to = e.type === 'focusout' ? e.relatedTarget : null; if (to && to.closest && to.closest('a[href],button')) return;
    (function check() {
      if (userScroll >= t0) return;
      var d = window.scrollY - y0;
      if (d !== 0 && Math.abs(d) < 240) window.scrollTo(0, y0);
      if (--left > 0) setTimeout(check, 50);
    })();
  }
  q.addEventListener('focusin', guard); q.addEventListener('focusout', guard);
})();

/* v0.48.3 sticky announcement bar: keep --ann equal to its height so the header and other sticky bars sit just below it */
(function () {
  function set() { var a = document.querySelector('.section-announce'); document.documentElement.style.setProperty('--ann', (a ? a.offsetHeight : 0) + 'px'); }
  set();
  var a = document.querySelector('.section-announce');
  if (a && 'ResizeObserver' in window) new ResizeObserver(set).observe(a);
  window.addEventListener('resize', set);
  document.addEventListener('shopify:section:load', set);
  document.addEventListener('shopify:section:unload', function () { setTimeout(set, 0); });
})();
